import React, { memo } from 'react';
import styles from './Styles/export-history.scss';
import { getDate, getExportDownloadLink, getExportErrorFileLink, getTime } from '../utils/bulkupdate.utils';
import ExportImportDownloadButton from './ExportImportDownloadButton';

export const GetUnderProcessFile = memo((props) => {
  const { data: { fileName, creationDateTime, completionPercentage, action } } = props;

  // let circleRef = React.useRef(null);
  return (
    <div className={styles['single-item']}>
      <div className={`${styles['status'] + ' ' + styles['uploading-file']}`}>
        <div id="cont" data-pct="100">
          <svg id="svg" width="2.4rem" height="2.4rem" version="1.1" xmlns="http://www.w3.org/2000/svg" viewport="0 0 1rem 1rem">
            <circle r="16" cx="1.2rem" cy="1.2rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset="0"></circle>
            <circle id="bar" r="16" cx="1.2rem" cy="1.2rem" fill="transparent" stroke-dasharray="100" stroke-dashoffset={`${100 - completionPercentage}`}>
            </circle>
          </svg>
          {/* <svg id="svg" width="5rem" height="5rem" viewPort="0 0 2.5rem 2.5rem" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <circle r="38" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset="0"></circle>
            <circle ref={circleRef} id="bar" r="38" cx="2.5rem" cy="2.5rem" fill="transparent" stroke-dasharray="239" stroke-dashoffset={`${239 - 239 * completionPercentage / 100}`}></circle>
          </svg> */}
          <div className={styles['catalogue-percentage']}>{Math.round(completionPercentage)}%</div>
        </div>
      </div>
      <div className={styles['desc-box']}>
        <div className={styles['filename']}>{fileName}</div>
        <div className={styles['status']}>
          <div>
            <p style={{ color: '#718190', fontSize: '12px' }}>
              {action === 'EXPORT' ? 'Exporting Inventory file' : 'Importing Inventory file'}
            </p>
          </div>
        </div>

      </div>
      <div className={styles['date-time']}>
        <div className={styles['date']}>{getDate(creationDateTime)}</div>
        <div className={styles['time']}>{getTime(creationDateTime)}</div>
      </div>
    </div>
  )
});

export const GetProcessedFile = memo((props) => {
  const { data: { fileName, creationDateTime, action, id: fileId, isLargeDataExport } } = props;

  return (
    <div className={styles['single-item']}>
      <div className={styles['status']}>
        <i className={'icon-Checkmark'} style={{ fontSize: 30, color: '#00B05A' }} />
      </div>
      <div className={styles['desc-box']}>
        <div className={styles['filename']}>{fileName}</div>
        <div className={styles['status']}>{action === 'EXPORT' ?
          <div>
            <p style={{ fontSize: '12px', color: '#718190', marginBottom: '10px' }}>
              {!isLargeDataExport ? 'Inventory file' : 'Bulk Updated Inventory file'} Exported Successfully</p>
            <ExportImportDownloadButton label="Download File" url={getExportDownloadLink(fileId)} fileName={fileName} />
          </div>
          : <p style={{ fontSize: '12px', color: '#718190' }}>Updated Successfully</p>}
        </div>

      </div>
      <div className={styles['date-time']}>
        <div className={styles['date']}>{getDate(creationDateTime)}</div>
        <div className={styles['time']}>{getTime(creationDateTime)}</div>
      </div>
    </div>
  )
})

export const GetPartiallyUpdated = memo((props) => {
  const { data: { id, fileName, creationDateTime, action, totalProductsSaved, totalCount , token } } = props;

  return (
    <div className={styles['single-item']}>
      <div className={styles['status']}>
        <i className={'icon-alert_outline'} style={{ fontSize: 30, color: '#FF9900' }} />
      </div>
      <div className={styles['desc-box']}>
        <div className={styles['filename']}>{fileName}</div>
        <div className={styles['status']}>{action === 'IMPORT' ?
          <div>
            <p style={{ fontSize: '12px', color: '#FF9900' }}>Partially Updated</p>
            <p style={{ fontSize: '12px', color: '#718190', marginBottom: '10px' }}>{totalProductsSaved}/{totalCount} Products Updated</p>
            <ExportImportDownloadButton label="Download Error File" url={getExportErrorFileLink(id, token)} fileName="error.xlsx" />
          </div>
          : <p style={{ fontSize: '12px', color: '#FF9900' }}>{totalProductsSaved}/{totalCount} Products Updated</p>}
        </div>

      </div>
      <div className={styles['date-time']}>
        <div className={styles['date']}>{getDate(creationDateTime)}</div>
        <div className={styles['time']}>{getTime(creationDateTime)}</div>
      </div>
    </div>
  )
})

export const GetErrorFile = memo((props) => {
  const { data: { id , fileName, creationDateTime, action, token } } = props;

  return (
    <div className={styles['single-item']}>
      <div className={styles['status']}>
        <i className={'icon-alert_outline'} style={{ fontSize: 30, color: '#C64C5C' }} />
      </div>
      <div className={styles['desc-box']}>
        <div className={styles['filename']}>{fileName}</div>
        <div className={styles['status']}>{action === 'IMPORT' ?
          <div>
            <p style={{ fontSize: '12px', color: '#C64C5C' }}>Update Failed</p>
            <p style={{ fontSize: '12px', color: '#718190', marginBottom: '10px' }}>No Products Updated</p>
            <ExportImportDownloadButton label="Download Error File" url={getExportErrorFileLink(id, token)} fileName="error.xlsx" />
          </div>
          : <p style={{ fontSize: '12px', color: '#718190' }}>No Products Updated</p>}
        </div>

      </div>
      <div className={styles['date-time']}>
        <div className={styles['date']}>{getDate(creationDateTime)}</div>
        <div className={styles['time']}>{getTime(creationDateTime)}</div>
      </div>
    </div>
  )
})